import { type EvaluationEmailRecipient as EvaluationEmailRecipientResponse } from "../api";
import { Utility } from "./utility";

export interface EvaluationEmailRecipient extends EvaluationEmailRecipientResponse {}

export class EvaluationEmailRecipient extends Utility<EvaluationEmailRecipient> {
  constructor(init?: Partial<EvaluationEmailRecipient>) {
    super();
    Object.assign(this, init);
  }
}
